const USER_KEY = "approvehub_referral_user";
const SALES_ZONE_KEY = "approvehub_referral_sales_zone";

export function setUserReferral(slug: string) {
  localStorage.setItem(USER_KEY, slug);
}

export function setSalesZoneReferral(slug: string) {
  localStorage.setItem(SALES_ZONE_KEY, slug);
}

export function getReferralIdentifiers(): {
  user_identifier?: string;
  sales_zone_identifier?: string;
} {
  if (typeof window === "undefined") return {};
  const user = localStorage.getItem(USER_KEY);
  const salesZone = localStorage.getItem(SALES_ZONE_KEY);
  return {
    ...(user ? { user_identifier: user } : {}),
    ...(salesZone ? { sales_zone_identifier: salesZone } : {}),
  };
}

export function clearReferral() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SALES_ZONE_KEY);
}
